import { formatDate, formatPrice } from '@/lib/utils.js';

const getOfferTitle = (offerInfo) => {
  if (!offerInfo) return 'Offre';
  const dbTitle = [
    offerInfo.raw?.titre_offre,
    offerInfo.raw?.titre,
    offerInfo.raw?.libelle,
    offerInfo.raw?.nom,
    offerInfo.details?.affichage?.titre,
  ]
    .map((value) => (typeof value === 'string' ? value.trim() : ''))
    .find((value) => value);
  if (dbTitle) return dbTitle;
  switch (offerInfo.typeOffre) {
    case 'n_plus_1':
      return 'Offre fidelite';
    case 'lot_moins_chere_offerte':
      return 'Offre epilation';
    case 'lot_prestations_prix_fixe':
      return 'Pack prestations';
    case 'remise_pourcent_categorie':
      return 'Remise';
    default:
      return 'Offre';
  }
};

const getOfferDetailsLine = (offerInfo) => {
  if (!offerInfo) return '';
  const details = offerInfo.details || {};
  const benefice = details.benefice || {};

  if (offerInfo.typeOffre === 'remise_pourcent_categorie') {
    const percent = parseInt(benefice.pourcentage, 10);
    if (Number.isFinite(percent) && percent > 0) {
      return `Remise de ${percent}%`;
    }
  }

  if (offerInfo.typeOffre === 'lot_moins_chere_offerte') {
    const threshold = parseInt(offerInfo?.details?.mecanique?.seuil, 10);
    const applicationTarif = offerInfo?.applicationTarif || benefice.application_tarif || 'public';
    if (Number.isFinite(threshold) && threshold > 1) {
      const tarifLabel =
        applicationTarif === 'tous'
          ? 'tarifs public et abonne'
          : applicationTarif === 'abonne'
            ? 'tarif abonne'
            : 'tarif public';
      return `${threshold} prestations achetees = la moins chere offerte (${tarifLabel})`;
    }
  }

  if (offerInfo.typeOffre === 'lot_prestations_prix_fixe') {
    const publicPrice = Number(benefice.prix_public_centimes);
    const abonnePrice = Number(benefice.prix_abonne_centimes);
    const targetCount = Array.isArray(offerInfo.targetPrestationIds)
      ? offerInfo.targetPrestationIds.length
      : Array.isArray(details.conditions?.prestation_ids)
        ? details.conditions.prestation_ids.length
        : 0;

    if (Number.isFinite(publicPrice) && Number.isFinite(abonnePrice)) {
      const countLabel = targetCount > 0 ? `${targetCount} prestations` : 'Pack';
      return `${countLabel}: ${formatPrice(abonnePrice)} club / ${formatPrice(publicPrice)} public`;
    }
  }

  return '';
};

export const renderOfferBlock = (offerInfo, { showDates = true } = {}) => {
  if (!offerInfo) return '';

  const title = getOfferTitle(offerInfo);
  const message = (offerInfo.message || '').trim();
  const detailsLine = getOfferDetailsLine(offerInfo);
  const dateLine =
    showDates && offerInfo.start && offerInfo.end
      ? `Du ${formatDate(offerInfo.start, 'short')} au ${formatDate(offerInfo.end, 'short')}`
      : '';

  return `
    <div class="offer-block offer-block--${offerInfo.typeOffre || 'generique'}">
      <div class="offer-block-title">${title}</div>
      ${message ? `<div class="offer-block-message">${message}</div>` : ''}
      ${detailsLine ? `<div class="offer-block-details">${detailsLine}</div>` : ''}
      ${dateLine ? `<div class="offer-block-dates">${dateLine}</div>` : ''}
    </div>
  `;
};
